import { useCallback, useState, useRef } from "react";

const useComparisonFocusManagement = () => {
  const [previousFocusedRef, setPreviousFocusedRef] = useState(null);
  const comparisonDrawerRef = useRef();

  const focusComparisonDrawer = useCallback((ref) => {
    setPreviousFocusedRef(ref);
    comparisonDrawerRef?.current?.focus();
    // Expand comparison drawer
    comparisonDrawerRef?.current?.click();
  }, []);

  const unFocusComparisonDrawer = useCallback(() => {
    previousFocusedRef?.current?.focus();
  }, [previousFocusedRef]);

  return {
    focusComparisonDrawer,
    unFocusComparisonDrawer,
    previousFocusedRef,
    comparisonDrawerRef,
  };
};

export default useComparisonFocusManagement;
